/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Grid } from '@mui/system';
import clsx from 'clsx';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function ServiceWeOffer({ serviceSection }) {
  const navigate = useNavigate();
  const [activeServiceCard, setActiveServiceCard] = useState(0);
  const isValidImage = (image) => image && typeof image.url === 'string';
  const isValidButton = (button) => button && typeof button.label === 'string';

  const handleNavigation = (url) => {
    navigate(url);
  };

  return (
    <div
      className="service-section-wrap"
      style={isValidImage(serviceSection.backgroundImage) ?
        { backgroundImage: `url(${serviceSection?.backgroundImage?.url})` } : {}}
  >
      <Grid
        container
        sx={{ justifyContent: 'space-between' }}
        className="section-top"
    >
        <Grid size={{ xs: 7, md: 6 }}>
          <div className="box-title">{serviceSection.title}</div>
        </Grid>
        <Grid
          container
          size={{ xs: 5, md: 5 }}
          sx={{ justifyContent: 'flex-end' }}
      >
          {isValidButton(serviceSection.button) && (
          <Button size="large" variant="contained" onClick={() => handleNavigation('/contact-us')}>
            {serviceSection?.button?.label.slice(0, 25)}
          </Button>
          )}
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          {serviceSection.subTitle && (
          <p className="box-subtitle">{serviceSection.subTitle}</p>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ justifyContent: 'space-between', marginTop: '36px' }}
        columnSpacing={{ xs: 3 }}
        rowSpacing={{ xs: 3 }}
    >
        <Grid size={{ xs: 12, md: 6 }}>
          <Grid container columnSpacing={{ xs: 2, md: 3 }} rowSpacing={{ xs: 2, md: 3 }}>
            {serviceSection?.cardList?.map((item, index) => (
              <Grid size={{ xs: 12, md: 6 }} container>
                <div className={clsx('service-field', { active: activeServiceCard === index })} onClick={() => setActiveServiceCard(index)} onMouseEnter={() => setActiveServiceCard(index)}>
                  <div className={clsx('title', { active: activeServiceCard === index })}>{item.title}</div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }} className="service-card-wrap">
          {serviceSection?.cardList?.map((item, index) => (
            <div>
              {activeServiceCard === index &&
              <>
                <div className="card-title">{item?.serviceCard?.title}</div>
                <div className="card-description">{item?.serviceCard?.description}</div>
                <div className="action-button" onClick={() => handleNavigation('/contact-us')}>{item?.serviceCard?.button?.label.slice(0, 25)}</div>
              </>}
            </div>
          ))}
        </Grid>
      </Grid>
    </div>
  );
}

export default ServiceWeOffer;
